import request from '@/utils/request'

export function getBiList(query) {
  return request({
    url: '/index/bis/getBiList',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}
